module.exports = __webpack_public_path__ + "img/004张嘉驿.58ec2a84.png";